// src/components/Common/CurrencySelector.jsx
import React from 'react';
import { Input } from 'reactstrap';
import { CURRENCIES_CATALOG } from '../../helpers/currencyHelper';

const CurrencySelector = ({
  value,
  onChange,
  className = '',
  id = 'currency-selector',
  name = 'currency_code',
  disabled = false,
  label = 'Currency',
  showSymbol = true,
}) => {
  return (
    <Input
      type="select"
      id={id}
      name={name}
      value={value || 'INR'}
      onChange={onChange}
      className={className}
      disabled={disabled}
    >
      {CURRENCIES_CATALOG.map((curr) => (
        <option key={curr.code} value={curr.code}>
          {curr.flag} {curr.name} ({curr.code} {showSymbol ? curr.symbol : ''})
        </option>
      ))}
    </Input>
  );
};

export default CurrencySelector;
